import { dfKey, formDataInStorage, getJsonItem, safeLocalStorageGetItem, safeLocalStorageRemoveItem, safeLocalStorageSetItem, } from "./helperLib";
var AGENT_SEARCH_MIN_CHARS = 2;
var AGENT_SEARCH_MAX_RESULTS = 4;
var HAU_FIELD_SUFFIX = "_HearAboutUs";
var AGENT_SEARCH_CLASS = "lo-picker";
var AGENT_SEARCH_FIELD_IDS = ["loName"];
var AGENT_SEARCH_DEFAULT_ERROR = "Please select a loan officer from the list";
var AGENT_STORAGE_KEYS = [
    "SelectedAgent",
    "agentid",
    "AgentName",
    "AgentIsILA",
];
export var HAU_REFERRED_BY_LO = "Referred by Loan Officer";
export var HAU_RETURNING_CUSTOMER = "Returning Customer";
export var AGENT_SEARCH_COPY = {
    placeholder: "Search for your loan officer by name",
    skip: "I don't have a loan officer.",
    loadError: "Unable to load loan officers. Try again later.",
};
var agentsCache = null;
var agentsLoadFailed = false;
var agentsReadyListeners = new Set();
export function isAgentSearchField(config) {
    var _a;
    if (AGENT_SEARCH_FIELD_IDS.includes(config.fieldId)) {
        return true;
    }
    return ((_a = config.className) !== null && _a !== void 0 ? _a : "").split(/\s+/).includes(AGENT_SEARCH_CLASS);
}
function normalizeAgentSearchValidationRule(rule) {
    var _a;
    if (Array.isArray(rule) && rule[0] === "loPicker") {
        return ["agentSearch", (_a = rule[1]) !== null && _a !== void 0 ? _a : AGENT_SEARCH_DEFAULT_ERROR];
    }
    return rule;
}
function getAgentSearchValidationRules(config) {
    if (Array.isArray(config.validation)) {
        return config.validation.map(normalizeAgentSearchValidationRule);
    }
    if (config.validation) {
        return [normalizeAgentSearchValidationRule(config.validation)];
    }
    return [["agentSearch", AGENT_SEARCH_DEFAULT_ERROR]];
}
function getAgentSearchErrorMessage(rules) {
    var _a, _b;
    for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
        var rule = rules_1[_i];
        if (Array.isArray(rule) && rule[0] === "agentSearch") {
            return String((_a = rule[1]) !== null && _a !== void 0 ? _a : AGENT_SEARCH_DEFAULT_ERROR);
        }
    }
    for (var _c = 0, rules_2 = rules; _c < rules_2.length; _c++) {
        var rule = rules_2[_c];
        if (Array.isArray(rule) && rule[0] === "required") {
            return String((_b = rule[1]) !== null && _b !== void 0 ? _b : "Required");
        }
    }
    return AGENT_SEARCH_DEFAULT_ERROR;
}
export function isAgentSearchRequired(config) {
    return getAgentSearchValidationRules(config).some(function (rule) { return rule === "required" || (Array.isArray(rule) && rule[0] === "required"); });
}
export function validateAgentSearchValue(value, config) {
    var rules = getAgentSearchValidationRules(config);
    var errorMessage = getAgentSearchErrorMessage(rules);
    var isRequired = rules.some(function (rule) { return rule === "required" || (Array.isArray(rule) && rule[0] === "required"); });
    var selection = parseAgentFieldValue(value);
    var hearAboutUs = getHearAboutUsValue();
    if (selection === null || selection === void 0 ? void 0 : selection.skipped) {
        return isReturningCustomerHau(hearAboutUs) ? "" : errorMessage;
    }
    if (selection === null || selection === void 0 ? void 0 : selection.agentGuid) {
        return "";
    }
    if (isRequired || isReferredByLoHau(hearAboutUs)) {
        return errorMessage;
    }
    return "";
}
function isHearAboutUsFieldKey(key) {
    return key.endsWith(HAU_FIELD_SUFFIX);
}
export function getHearAboutUsValue() {
    var _a, _b;
    var formData = formDataInStorage();
    for (var _i = 0, _c = Object.keys(formData); _i < _c.length; _i++) {
        var key = _c[_i];
        if (!isHearAboutUsFieldKey(key)) {
            continue;
        }
        var value = (_b = (_a = formData[key]) === null || _a === void 0 ? void 0 : _a.fieldValue) !== null && _b !== void 0 ? _b : formData[key];
        if (value) {
            return String(value);
        }
    }
    var df = getJsonItem(dfKey()) || {};
    for (var _d = 0, _e = Object.keys(df); _d < _e.length; _d++) {
        var key = _e[_d];
        if (!isHearAboutUsFieldKey(key)) {
            continue;
        }
        var value = df[key];
        if (value != null && typeof value !== "object") {
            return String(value);
        }
    }
    return "";
}
function notifyAgentsReady() {
    agentsReadyListeners.forEach(function (cb) { return cb(); });
    agentsReadyListeners.clear();
}
export function didAgentsLoadFail() {
    return agentsLoadFailed;
}
export function onAgentsReady(cb) {
    if (agentsCache === null || agentsCache === void 0 ? void 0 : agentsCache.length) {
        cb();
        return function () { return undefined; };
    }
    agentsReadyListeners.add(cb);
    return function () {
        agentsReadyListeners.delete(cb);
    };
}
export function isReturningCustomerHau(hauValue) {
    if (hauValue === void 0) { hauValue = getHearAboutUsValue(); }
    return hauValue === HAU_RETURNING_CUSTOMER;
}
export function isReferredByLoHau(hauValue) {
    if (hauValue === void 0) { hauValue = getHearAboutUsValue(); }
    return hauValue === HAU_REFERRED_BY_LO;
}
export function shouldShowAgentTypeahead(hauValue) {
    if (hauValue === void 0) { hauValue = getHearAboutUsValue(); }
    return isReferredByLoHau(hauValue) || isReturningCustomerHau(hauValue);
}
export function shouldShowAgentSkipControl(hauValue) {
    if (hauValue === void 0) { hauValue = getHearAboutUsValue(); }
    return isReturningCustomerHau(hauValue);
}
export function sanitizeAgentNameInput(value) {
    return value.replace(/[^a-zA-Z\s]/g, "");
}
export function skippedAgentSelection() {
    return { displayName: "", agentGuid: "", skipped: true };
}
function getWindowAgents() {
    var agents = window.Agents;
    return Array.isArray(agents) ? agents : [];
}
function getAgentsList() {
    return agentsCache !== null && agentsCache !== void 0 ? agentsCache : getWindowAgents();
}
export function ensureAgentsLoaded() {
    if (agentsCache !== null) {
        return;
    }
    var existingAgents = getWindowAgents();
    agentsCache = existingAgents.length > 0 ? existingAgents : [];
    agentsLoadFailed = agentsCache.length === 0;
    notifyAgentsReady();
}
export function maybeLoadAgentsForSearch(hauValue) {
    if (hauValue === void 0) { hauValue = getHearAboutUsValue(); }
    if (hauValue === HAU_REFERRED_BY_LO || hauValue === HAU_RETURNING_CUSTOMER) {
        ensureAgentsLoaded();
    }
}
function getAgentDisplayName(agent) {
    return "".concat(agent.firstName || "", " ").concat(agent.lastName || "").trim();
}
function getAgentNumericId(agent) {
    var _a;
    var numericId = (_a = agent.agentID) !== null && _a !== void 0 ? _a : agent.userId;
    return numericId != null && numericId > 0 ? String(numericId) : "";
}
function getAgentNmls(agent) {
    var _a, _b;
    return ((_b = ((_a = agent.nmls) !== null && _a !== void 0 ? _a : agent.nmlsLicenseNumber)) === null || _b === void 0 ? void 0 : _b.trim()) || undefined;
}
function getAgentEmail(agent) {
    var _a, _b;
    return ((_b = ((_a = agent.emailAddress) !== null && _a !== void 0 ? _a : agent.email)) === null || _b === void 0 ? void 0 : _b.trim()) || undefined;
}
function getAgentPhone(agent) {
    var _a, _b, _c;
    var raw = (_c = (_b = (_a = agent.mobilePhone) !== null && _a !== void 0 ? _a : agent.mobilePhoneNumber) !== null && _b !== void 0 ? _b : agent.directPhone) !== null && _c !== void 0 ? _c : "";
    return raw.replace(/[^0-9]/g, "");
}
function getAgentPageName(agent) {
    var _a, _b;
    return ((_b = ((_a = agent.subDomain) !== null && _a !== void 0 ? _a : agent.agentPageName)) === null || _b === void 0 ? void 0 : _b.trim()) || "";
}
export function agentToSelection(agent) {
    var _a;
    var agentGuid = (_a = agent.agentUID) === null || _a === void 0 ? void 0 : _a.trim();
    if (!agentGuid) {
        return null;
    }
    var displayName = getAgentDisplayName(agent);
    if (!displayName) {
        return null;
    }
    var loPhone = getAgentPhone(agent);
    return {
        displayName: displayName,
        agentGuid: agentGuid,
        agentId: getAgentNumericId(agent) || agentGuid,
        loNmls: getAgentNmls(agent),
        loEmail: getAgentEmail(agent),
        loPhone: loPhone || undefined,
    };
}
function applyAgentToLocalStorage(agent) {
    var _a, _b;
    var agentGuid = (_a = agent.agentUID) === null || _a === void 0 ? void 0 : _a.trim();
    if (!agentGuid) {
        return;
    }
    var displayName = getAgentDisplayName(agent);
    var agentPhone = getAgentPhone(agent);
    var selectedAgent = {
        AgentId: getAgentNumericId(agent),
        GUID: agentGuid,
        Name: displayName,
        JobTitle: ((_b = agent.jobTitle) === null || _b === void 0 ? void 0 : _b.trim()) || "",
        PageName: getAgentPageName(agent),
        AgentPhone: agentPhone,
        AgentIsILA: agent.isIla ? "true" : "",
    };
    safeLocalStorageSetItem("SelectedAgent", JSON.stringify(selectedAgent));
    safeLocalStorageSetItem("agentid", agentGuid);
    if (displayName) {
        safeLocalStorageSetItem("AgentName", displayName);
    }
    safeLocalStorageSetItem("AgentIsILA", selectedAgent.AgentIsILA);
    if (agentPhone) {
        safeLocalStorageSetItem("phoneDisplay", agentPhone);
    }
}
export function clearAgentFromLocalStorage() {
    AGENT_STORAGE_KEYS.forEach(function (key) { return safeLocalStorageRemoveItem(key); });
}
export function shouldPersistAgentSelection(selection) {
    var _a;
    return Boolean(selection && !selection.skipped && ((_a = selection.agentGuid) === null || _a === void 0 ? void 0 : _a.trim()));
}
export function syncAgentSelectionToLocalStorage(selection) {
    if (!shouldPersistAgentSelection(selection) || !selection) {
        return;
    }
    var agent = findAgentByGuid(selection.agentGuid);
    if (agent) {
        applyAgentToLocalStorage(agent);
    }
}
export function findAgentByGuid(guid) {
    if (!guid) {
        return undefined;
    }
    var normalized = guid.replace(/["']/g, "").trim().toLowerCase();
    if (!normalized) {
        return undefined;
    }
    return getAgentsList().find(function (agent) { return (agent.agentUID || "").trim().toLowerCase() === normalized; });
}
function searchAgents(query) {
    var normalizedValue = query.trim().toLowerCase();
    if (normalizedValue.length < AGENT_SEARCH_MIN_CHARS) {
        return [];
    }
    return getAgentsList()
        .filter(function (agent) {
        var _a;
        if (!((_a = agent.agentUID) === null || _a === void 0 ? void 0 : _a.trim()) || !getAgentPageName(agent)) {
            return false;
        }
        var fullName = getAgentDisplayName(agent).toLowerCase();
        return fullName.length > 0 && fullName.includes(normalizedValue);
    })
        .slice(0, AGENT_SEARCH_MAX_RESULTS);
}
export function searchAgentSuggestions(query) {
    return searchAgents(query).map(function (agent) {
        var name = getAgentDisplayName(agent);
        return {
            id: agent.agentUID || name,
            label: name,
        };
    });
}
export function serializeAgentFieldValue(selection) {
    if (!selection) {
        return "";
    }
    return JSON.stringify(selection);
}
export function parseAgentFieldValue(value) {
    var _a;
    if (!(value === null || value === void 0 ? void 0 : value.trim())) {
        return null;
    }
    try {
        var parsed = JSON.parse(value);
        if (parsed === null || parsed === void 0 ? void 0 : parsed.skipped) {
            return { displayName: "", agentGuid: "", skipped: true };
        }
        if ((_a = parsed === null || parsed === void 0 ? void 0 : parsed.agentGuid) === null || _a === void 0 ? void 0 : _a.trim()) {
            return parsed;
        }
    }
    catch (_b) {
        return null;
    }
    return null;
}
export function getPrefilledSelectionFromStorage() {
    var storedGuid = safeLocalStorageGetItem("agentid");
    var agent = findAgentByGuid(storedGuid);
    return agent ? agentToSelection(agent) : null;
}
export function hasCommittedAgentSelection(selection, inputValue) {
    if (!(selection === null || selection === void 0 ? void 0 : selection.agentGuid) || selection.skipped) {
        return false;
    }
    return inputValue.trim() === selection.displayName;
}
